import { useState, useMemo, useEffect } from 'react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { useToggleArchiveETicketTypeMutation, useGetArchivedETicketTypeMutation, useGetUnarchivedETicketTypeMutation, usePostETicketTypeMutation, usePutETicketTypeMutation, } from '@services/product/eTicketType/e-ticket-type.endpoints';
import { ETicketType } from '@services/product/eTicketType/e-ticket-type.types';

export const useETicketTypesPageVM = () => {
    const [isArchived, setIsArchived] = useState<boolean>(false);
    const [needReload, setNeedReload] = useState<boolean>();
    const MySwal = withReactContent(Swal);

    const [
        updateETicketType,
        {
            isSuccess: isUpdateETicketTypeSuccess
        }
    ] = usePutETicketTypeMutation();


    const [
        createETicketType,
        {
            isSuccess: isCreateETicketTypeSuccess
        }
    ] = usePostETicketTypeMutation();


    const [
        toggleArchiveETicketType, 
        {
            isSuccess: isToggleArchiveETicketTypeSuccess
        }
    ] = useToggleArchiveETicketTypeMutation();

    const handleToggleArchiveETicketType = (id: number, archive: boolean) => {
        MySwal.fire({
            title: archive ? 'Êtes-vous sûr de vouloir archiver ce type de e-billet ?' : 'Êtes-vous sûr de vouloir désarchiver ce type de e-billet ?',
            icon: 'warning',
            showCancelButton: true,
            iconColor: '#5D4B99',
            confirmButtonColor: '#5D4B99',
            confirmButtonText: archive ? 'Archiver' : 'Désarchiver',
            cancelButtonText: 'Annuler',
        }).then((result) => {
            if (result.isConfirmed) {
                toggleArchiveETicketType({ id, archived: archive });
            }
        })
    }

    const handleToggleArchiveETicketTypes = (lines: ETicketType[], archive: boolean) => {
        MySwal.fire({
            title: archive ? 'Êtes-vous sûr de vouloir archiver ces types de e-billets ?' : 'Êtes-vous sûr de vouloir désarchiver ces types de e-billets ?',
            icon: 'warning',
            showCancelButton: true,
            iconColor: '#5D4B99',
            confirmButtonColor: '#5D4B99',
            confirmButtonText: archive ? 'Archiver' : 'Désarchiver',
            cancelButtonText: 'Annuler',
        }).then((result) => {
            if (result.isConfirmed) {
                lines.forEach((line) => {
                    toggleArchiveETicketType({ id: line.id, archived: archive });
                });
            }
        })
    }

  

    useEffect(() => {
        if(isCreateETicketTypeSuccess || isUpdateETicketTypeSuccess || isToggleArchiveETicketTypeSuccess) {
            setNeedReload((prev) => !prev);
        }
    }, [isCreateETicketTypeSuccess, isUpdateETicketTypeSuccess, isToggleArchiveETicketTypeSuccess]);


    const mutationHook = useMemo(() => {
        return isArchived ? useGetArchivedETicketTypeMutation : useGetUnarchivedETicketTypeMutation;
    }, [isArchived]);

    return {
        mutationHook,
        isArchived,
        needReload,
        setIsArchived,
        createETicketType,
        updateETicketType,
        MySwal,
        handleToggleArchiveETicketType,
        handleToggleArchiveETicketTypes
    };
};
